// Sentry must be initialized before React renders
import '../sentry.client.config.js';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { initKnkTracking } from './lib/knkTracking.js'

// K&K ad tracking reads the landing URL, so it runs before the router renders.
initKnkTracking()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
